import { UseMutationResult, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { APIError } from '@data';
import { notificationsKeys, unreadNotificationsKeys } from '@data/constants';
import { NotificationCountView, NotificationReadBody } from '@data/sdk/match';
import { MatchingApi } from '@data/utils/axios-instance';

export const useMarkNotificationsAsRead = (): UseMutationResult<
  unknown,
  APIError,
  NotificationReadBody,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (values) => {
      const response = await MatchingApi.notifications.markNotificationsAsRead({
        notificationReadBody: values,
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.list() });
      queryClient.invalidateQueries({ queryKey: unreadNotificationsKeys.all() });
    },
  });
};

export const useUnreadNotificationsCount = (enabled = true) =>
  useQuery<NotificationCountView, Error>({
    queryKey: unreadNotificationsKeys.all(),
    queryFn: async () => {
      const response = await MatchingApi.notifications.getUnreadNotificationsCount();
      return response.data;
    },
    refetchInterval: 60_000,
    enabled,
  });
